var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-container" }, [
    _c(
      "div",
      { staticClass: "modal-header" },
      [
        _c("h4", { staticClass: "modal-title" }, [
          _vm._v(_vm._s(_vm.modalTitle)),
        ]),
        _c(
          "md-button",
          {
            staticClass: "md-simple md-just-icon md-round modal-default-button",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.$modal.hide($event)
              },
            },
          },
          [_c("md-icon", [_vm._v("clear")])],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "modal-body" },
      [
        _c(
          "form-wrapper",
          {
            staticClass: "form-wrapper",
            attrs: { validator: _vm.$v.locationDetails },
          },
          [
            _c(
              "div",
              { staticClass: "form-container location-form-container" },
              [
                _c(
                  "form-group",
                  { attrs: { name: "locationName", label: "Location Name" } },
                  [
                    _c("md-input", {
                      directives: [{ name: "focus", rawName: "v-focus" }],
                      model: {
                        value: _vm.locationDetails.locationName,
                        callback: function ($$v) {
                          _vm.$set(_vm.locationDetails, "locationName", $$v)
                        },
                        expression: "locationDetails.locationName",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "form-group",
                  {
                    attrs: {
                      name: "barcode",
                      label:
                        "Barcode (optional - auto-generated if left blank)",
                    },
                  },
                  [
                    _c("md-input", {
                      model: {
                        value: _vm.locationDetails.barcode,
                        callback: function ($$v) {
                          _vm.$set(_vm.locationDetails, "barcode", $$v)
                        },
                        expression: "locationDetails.barcode",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "form-group",
                  { attrs: { name: "notes", label: "Notes" } },
                  [
                    _c("md-input", {
                      model: {
                        value: _vm.locationDetails.notes,
                        callback: function ($$v) {
                          _vm.$set(_vm.locationDetails, "notes", $$v)
                        },
                        expression: "locationDetails.notes",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "color-form-group" },
                  [
                    _c(
                      "form-group",
                      { attrs: { name: "color", label: "Color" } },
                      [
                        _c("md-input", {
                          model: {
                            value: _vm.locationDetails.color,
                            callback: function ($$v) {
                              _vm.$set(_vm.locationDetails, "color", $$v)
                            },
                            expression: "locationDetails.color",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.locationDetails.color,
                          expression: "locationDetails.color",
                        },
                      ],
                      staticClass: "color-picker",
                      attrs: { type: "color" },
                      domProps: { value: _vm.locationDetails.color },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.locationDetails,
                            "color",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "form-group",
                  { attrs: { name: "locationType", label: "Type" } },
                  [
                    _c(
                      "md-select",
                      {
                        model: {
                          value: _vm.locationDetails.locationType,
                          callback: function ($$v) {
                            _vm.$set(_vm.locationDetails, "locationType", $$v)
                          },
                          expression: "locationDetails.locationType",
                        },
                      },
                      _vm._l(_vm.locationChoices, function (choice) {
                        return _c(
                          "md-option",
                          { key: choice, attrs: { value: choice } },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(choice) +
                                "\n                        "
                            ),
                          ]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "modal-footer" },
      [
        _c(
          "md-button",
          {
            staticClass: "dialog-button md-primary",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.save($event)
              },
            },
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.isUpdateFlag ? "Update" : "Create") +
                "\n        "
            ),
          ]
        ),
        _c(
          "md-button",
          {
            staticClass: "dialog-button md-default",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.$modal.hide($event)
              },
            },
          },
          [_vm._v("Cancel")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }